var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "boss-skill-sheet" }, [
    _c("table", { staticClass: "unstriped boss-table" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("tbody", [
        _c("tr", [
          _c("td", { staticClass: "boss-table-data" }, [
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.inputComment,
                  expression: "inputComment",
                },
              ],
              class: ["boss-send-textarea", "pega-textarea-resize-none"],
              attrs: { "data-test": "comment" },
              domProps: { value: _vm.inputComment },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.inputComment = $event.target.value
                },
              },
            }),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "boss-layout boss-layout-center" }, [
      _c(
        "button",
        {
          staticClass: "boss-button boss-button-confirm pega-button",
          attrs: { "data-test": "save" },
          on: { click: _vm.save },
        },
        [_vm._v("\n      コメントを更新\n    ")]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "boss-table-head" }, [
          _vm._v("\n          コメント\n        "),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }